import get from 'lodash/get'

/**
 * middleware to handle errors
 * @param {object} customActions
 *  {
 *    error: [errorAction],
 *    forbidden: [logoutAction, notifyAction]
 *  }
 */

export default (customActions = {}) => {
    /**
     * build error actions
     */
    const actions = {
        error: [...(customActions.error || [])],
        forbidden: [...(customActions.forbidden || [])],
        unauthorized: [...(customActions.unauthorized || [])]
    }

    /**
     * dispatches each error action
     */
    const dispatchErrorActions = (store, error, error_actions) => {
        error_actions.forEach(action => {
            if (typeof action === 'function') {
                return store.dispatch(action(error))
            }

            return store.dispatch(action)
        })
    }

    /**
     * returns action type based on response status
     */
    const getActionType = (error = {}) => {
        switch (error.response && error.response.status) {
            case 401:
                return 'unauthorized'
            case 403:
                return 'forbidden'
            default:
                return 'error'
        }
    }

    /**
     * dispatch actions based on error type - 403, etc.
     */
    return store => next => action => {
        const error = get(action, 'payload.error')
        if (error) {
            dispatchErrorActions(store, error, actions[getActionType(error)])
        }
        return next(action)
    }
}



// WEBPACK FOOTER //
// ./middlewares/errorMiddleware.js